import Context from "shared/util/Context";

export const INITIAL_STATE = {
	boostTokenCount: 0,
	hasIncognitoEnabled: false,
	isBoosting: false,
	multiplier: null,
	boostEndTime: null,
	boostStartTime: null,
	isFinishedBoostModalOpen: false,
};

const SET_BOOST_TOKEN_COUNT = "NAVBAR.SET_BOOST_TOKEN_COUNT";
const SET_INCOGNITO_ENABLED = "NAVBAR.SET_INCOGNITO_ENABLED";
const IS_BOOSTING = "NAVBAR.IS_BOOSTING";
const END_BOOST = "NAVBAR.END_BOOST";
const START_BOOST = "NAVBAR.START_BOOST";
const SET_BOOST_MULTIPLIER = "NAVBAR.SET_BOOST_MULTIPLIER";
const SYNC_BOOST = "NAVBAR.SYNC_BOOST";
const CLOSE_BOOST_MODAL = "NAVBAR.CLOSE_BOOST_MODAL";

const getInitialState = () => {
	if (!window || !window.BoostController || !window.BoostController.Model) return INITIAL_STATE;

	const newState = {
		boostTokenCount: window.BoostController.Model.get("tokens"),
		hasIncognitoEnabled: Context.get("hasIncognitoEnabled"),
		isBoosting: window.BoostController.Model.get("state") === "running",
		multiplier: +window.BoostController.Model.get("attentionMultiplier"),
	};

	return {
		...INITIAL_STATE,
		...newState,
	};
};

export function reducer(state = getInitialState(), action) {
	switch (action.type) {
		case SET_BOOST_TOKEN_COUNT: {
			const {
				tokenCount,
			} = action.payload;

			return {
				...state,
				boostTokenCount: tokenCount,
			};
		}

		case SET_INCOGNITO_ENABLED: {
			const {
				hasIncognitoEnabled,
			} = action.payload;

			return {
				...state,
				hasIncognitoEnabled,
			};
		}

		case IS_BOOSTING: {
			const {
				isBoosting,
			} = action.payload;

			return {
				...state,
				isBoosting,
			};
		}

		case END_BOOST: {
			return {
				...state,
				isBoosting: false,
				boostEndTime: null,
				boostStartTime: null,
				multiplier: null,
				isFinishedBoostModalOpen: true,
			};
		}

		case SYNC_BOOST: {
			const {
				boostEndTime,
				boostStartTime,
			} = action.payload;

			return {
				...state,
				boostEndTime,
				boostStartTime,
			};
		}

		case START_BOOST: {
			const {
				boostEndTime,
				boostStartTime,
			} = action.payload;

			return {
				...state,
				boostEndTime,
				boostStartTime,
				isBoosting: true,
			};
		}

		case SET_BOOST_MULTIPLIER: {
			const {
				multiplier,
			} = action.payload;

			return {
				...state,
				multiplier,
			};
		}

		case CLOSE_BOOST_MODAL: {
			return {
				...state,
				isFinishedBoostModalOpen: false,
			};
		}

		default:
			return state;
	}
}

export function setBoostTokenCount(tokenCount) {
	return {
		type: SET_BOOST_TOKEN_COUNT,
		payload: {
			tokenCount,
		},
	};
}

export function setIncognitoState(hasIncognitoEnabled) {
	return {
		type: SET_INCOGNITO_ENABLED,
		payload: {
			hasIncognitoEnabled,
		},
	};
}

export function endBoost() {
	return {
		type: END_BOOST,
	};
}

export function startBoost(boostEndTime, boostStartTime) {
	return {
		type: START_BOOST,
		payload: {
			boostEndTime,
			boostStartTime,
		},
	};
}

export function setBoostMultiplier(multiplier) {
	return {
		type: SET_BOOST_MULTIPLIER,
		payload: {
			multiplier,
		},
	};
}

export function syncBoost(boostEndTime, boostStartTime) {
	return {
		type: SYNC_BOOST,
		payload: {
			boostEndTime,
			boostStartTime,
		},
	};
}

export function closeFinishedBoostModal() {
	return {
		type: CLOSE_BOOST_MODAL,
	};
}



// WEBPACK FOOTER //
// ./src/ducks/navbar.js